import { render, staticRenderFns } from "./ModalCommande.vue?vue&type=template&id=501587d0&scoped=true&"
import script from "./ModalCommande.vue?vue&type=script&lang=js&"
export * from "./ModalCommande.vue?vue&type=script&lang=js&"
import style0 from "./ModalCommande.vue?vue&type=style&index=0&id=501587d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501587d0",
  null
  
)

export default component.exports